import { RatingIcons, Stack } from '@packages/shared';
import type { RatingProduct } from '@packages/gql/generated/shopping/graphql';
import { useConfig } from '@packages/utilities';
import { RatingInfo } from '../CustomerRatings';

export type RatingIconsVerifiedProps = {
  avgRating: RatingProduct['avgRating'];
  reviewCount: RatingProduct['reviewCount'];
};

/**
 * RatingIconsVerified component shows review-icons,
 * the amount of given ratings and an information-icon
 * */
export const RatingIconsVerified = ({ avgRating, reviewCount }: RatingIconsVerifiedProps) => {
  const {
    product: {
      reviews: { hintLayerId },
    },
  } = useConfig();

  return (
    <Stack direction="row">
      <RatingIcons
        avgRating={avgRating}
        reviewCount={reviewCount}
        sx={{
          cursor: 'pointer',
        }}
        onClick={() => {
          document
            .getElementById('customer-ratings')
            ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }}
      />
      <RatingInfo verifiedRatingsHintLayerId={hintLayerId} />
    </Stack>
  );
};
